export class PCardModel {
    public id = 0;
    public type = 0;
    public level = 0;
    public subtype = "Subtype";
    public description = "Description";
    public target:number[] = [];
    public unlockSuspects:number[] = [];
    public unlockWhiteboard:string[] = [];
}